import { E as n, f as c, Q as i, u as s, q as f, U as p } from "./export-cdcbfb2b.js";
import { o as l } from "./object-create-9b6715a2.js";
var u = c, v = n, y = i, S = v("species"), V = function(r) {
  return y >= 51 || !u(function() {
    var e = [], o = e.constructor = {};
    return o[S] = function() {
      return { foo: 1 };
    }, e[r](Boolean).foo !== 1;
  });
}, P = n, d = l, b = s.f, a = P("unscopables"), t = Array.prototype;
t[a] === void 0 && b(t, a, {
  configurable: !0,
  value: d(null)
});
var $ = function(r) {
  t[a][r] = !0;
}, m = f, w = s, E = p, A = function(r, e, o) {
  m ? w.f(r, e, E(0, o)) : r[e] = o;
};
export {
  V as a,
  $ as b,
  A as c
};
